import React from 'react';

// Ref-counted body scroll lock shared across overlays. The last overlay to
// unmount restores the original overflow, so a popup opened over the inventory
// detail modal doesn't re-enable background scrolling when it closes.
const lockState = new WeakMap(); // body -> { count, prevOverflow }

function useScrollLock(enabled, getDocument) {
    React.useEffect(() => {
        if (!enabled) {
            return;
        }
        const body = ((getDocument && getDocument()) || document).body;
        let state = lockState.get(body);
        if (!state) {
            state = { count: 0, prevOverflow: body.style.overflow };
            lockState.set(body, state);
        }
        state.count++;
        body.style.overflow = 'hidden';
        return () => {
            state.count--;
            if (state.count <= 0) {
                body.style.overflow = state.prevOverflow || '';
                lockState.delete(body);
            }
        };
    }, [enabled]);
}

export default useScrollLock;
